import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from './redux/store'
import Header from './nav'
import ThemeProvider from "./common/theme/Provider"

ReactDOM.render(
    <Provider store={store}>
      <ThemeProvider>
        <Header />
      </ThemeProvider>
    </Provider>,
    document.getElementById('buoy_header'));


// WEBPACK FOOTER //
// ./assets/header.js